import * as Service from 'types/service';
import { ServiceState } from 'state/service/app';
import { TopicChangeRequest } from 'state/service/appTs/types';
import { core } from '@tock/coretypes';
import { deselectParty } from 'actions/service/ui/partyDisplayActions';
import { deselectTables } from 'actions/service/ui/tableActions';
import { getExistingCommunicatorForTopic } from 'utils/service/topicUtils';
import { isInCorrectDateFormat } from 'utils/timeUtils';
import { selectSidebarTab } from 'actions/service/ui/sidebarTabActions';
import { setActiveBusinessCookieHelper } from 'utils/service/cookieUtils';
import SidebarTabConstants from 'constants/service/SidebarTabConstants';
import rootElmAction, { RootElmActionReturnType } from 'actions/service/rootElmAction';

export interface FunctionTypes {
  clearToast(): RootElmActionReturnType;
  displayError(errorToShow: string): RootElmActionReturnType;
  markHistoryItemsAsRead(): RootElmActionReturnType;
  setIsReadOnly(isReadOnly: boolean): RootElmActionReturnType;
  setHistoryToggledOn(historyToggledOn: boolean): RootElmActionReturnType;
  setTopic(
    selectedBusiness: core.Business,
    serviceDate: string,
    currentBusiness?: core.Business,
    state?: ServiceState
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): (dispatch: (action: any) => void) => RootElmActionReturnType;
}

export function clearToast() {
  return rootElmAction('clearError', {});
}

export function displayError(errorToShow: string) {
  return rootElmAction('displayError', errorToShow);
}

export function markHistoryItemsAsRead() {
  return rootElmAction('markHistoryItemsAsRead', {});
}

export function setIsReadOnly(isReadOnly: boolean) {
  return rootElmAction('setIsReadOnly', isReadOnly);
}

export function setHistoryToggledOn(historyToggledOn: boolean) {
  return rootElmAction('setHistoryToggledOn', historyToggledOn);
}

export function sendHistoryLatestEventId(eventId: number) {
  return rootElmAction('setHistoryLatestEventId', eventId);
}

export function setTopic(
  selectedBusiness: Service.MassagedBusiness,
  serviceDate: string,
  currentBusiness?: Service.MassagedBusiness,
  state?: ServiceState
) {
  return (dispatch: Dispatch) => {
    dispatch(deselectParty());
    dispatch(deselectTables());
    dispatch(selectSidebarTab(SidebarTabConstants.GuestsTab));
    dispatch(setTopicInternal(selectedBusiness, serviceDate, currentBusiness, state));
  };
}

function setTopicInternal(
  selectedBusiness: Service.MassagedBusiness,
  serviceDate: string,
  currentBusiness?: Service.MassagedBusiness,
  state?: ServiceState
) {
  if (!selectedBusiness || !serviceDate || !isInCorrectDateFormat(serviceDate)) {
    return {
      type: 'NOOP',
    };
  }

  if (!currentBusiness || selectedBusiness.id !== currentBusiness.id) {
    setActiveBusinessCookieHelper(selectedBusiness);
  }

  const newTopic = { everConnected: false, selectedBusiness, serviceDate };
  const changeTopicRequest: TopicChangeRequest = { newTopic };

  const existingCommunicator = getExistingCommunicatorForTopic(newTopic);
  if (existingCommunicator) {
    changeTopicRequest.existingCommunicator = existingCommunicator;
  }
  if (state) {
    changeTopicRequest.model = state;
  }

  return rootElmAction('setTopic', changeTopicRequest);
}
